import { browserHistory } from 'browserHistory';
import firebase from 'firebase/app';
import {
  createAuthCookie,
  fetchUserAccessInformation,
  sessionLogin,
} from './authentication';
import { RoleType } from '../../types/userTypes';

function redirectBasedOnRole(roleType: RoleType) {
  if (roleType === RoleType.ADMIN) {
    browserHistory.push('/dashboard');
    window.location.reload();
  }
}

export async function signIn(
  email: string,
  password: string
): Promise<[boolean, string]> {
  try {
    const response = await firebase
      .auth()
      .signInWithEmailAndPassword(email, password);

    const token = await response.user.getIdToken();
    const sessionToken = await sessionLogin(token);

    if (!sessionToken) {
      return [false, 'There was a login error try again'];
    }

    const accessInfo = await fetchUserAccessInformation(sessionToken);
    if (accessInfo.role === RoleType.ADMIN) {
      createAuthCookie(sessionToken, response, accessInfo);
      redirectBasedOnRole(accessInfo.role);
      return [true, 'Signing in as dispatcher'];
    } else if (accessInfo.role === RoleType.COURIER) {
      return [false, 'Please try logging in with the app'];
    } else {
      return [
        false,
        'You are trying to login with a not supported account, please login as a dispatcher or a courier',
      ];
    }
  } catch (e) {
    console.log('Error signing in', e);
    return [false, 'Error signing in'];
  }
}
